<template>
  <div class="py-2 px-1">
    <v-card class="rounded-t-lg">
      <v-card-title class="title style-color-main-gray">
        <v-btn
            @click="returnParent()" class="  black--text" icon small>
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span>Список интервалов {{ detailData.name }}  </span>
        <v-spacer></v-spacer>
        <v-btn @click="openCreateDialog" color="secondary" text>
          <v-icon>add</v-icon>
        </v-btn>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
                @click="reloadData()"
                class="mr-2"
                medium
                v-on="on"
            >
              update
            </v-icon>
          </template>
          <span>Обновить данные</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="getItems"
          :loading="isLoading"
          :footer-props="{'items-per-page-options':[25,50,100]}"
          no-data-text="Данные отсутствуют"
          no-results-text="Ничего не было найдено"
      >
        <template v-slot:item.is_blocked="{ item }">
          <v-icon v-if="item.is_blocked">done</v-icon>
          <v-icon v-else>clear</v-icon>
        </template>
        <template v-slot:item.start_intervals="{ item }">
          <span>{{ item.start_intervals }}</span>
        </template>
        <template v-slot:no-data>
          <v-card-text>Данные не загружены</v-card-text>
        </template>
        <template v-slot:item.btn="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  @click="transferRecords(item)"
                  class="mr-2"
                  medium
                  v-on="on"
              >
                calendar_month
              </v-icon>
            </template>
            <span>Перенести записи</span>
          </v-tooltip>
          <v-tooltip v-if="!item.is_blocked" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  medium
                  @click="openBlockDialog(item,true)"
              >
                dangerous
              </v-icon>
            </template>
            <span>Заблокировать интервал</span>
          </v-tooltip>
          <v-tooltip v-if="item.is_blocked" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  medium
                  @click="openBlockDialog(item,false)"
              >
                restore
              </v-icon>
            </template>
            <span>Разблокировать интервал</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  medium
                  @click="openEditDialog(item)"
              >
                edit
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip v-if="!item.week_day" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  medium
                  @click="openDeleteDialog(item)"
              >
                delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :docs_data="docs_data"
        @close="closeEditDialog"
    ></EditDialog>
    <EditTransferDialog
        v-if="dialog_add_transfer"
        :opened="dialog_add_transfer"
        :docs_data="docs_data"
        @close="closeEditDialog"
    ></EditTransferDialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить ?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
    <ApplyDialog
        v-if="blockInterval.open"
        :opened="blockInterval.open"
        :get-text="() => blockInterval.block ? `Вы уверены, что хотите заблокировать ?`:`Вы уверены, что хотите разблокировать ?`"
        @close="closeBlockDialog"
    ></ApplyDialog>
  </div>

</template>


<script>

import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";

import names from "@/modules/recording/routers/names";
import {displayDate} from "@/helper";
import EditDialog from "@/modules/recording/page/admin/events/intervals/EditDialog.vue";
import ApplyDialog from "@/modules/templates/ApplyDialog.vue";
import {mapActions, mapGetters} from "vuex";
import EditTransferDialog from "@/modules/recording/page/admin/events/intervals/EditTransferDialog.vue";


export default {
  name: "List",
  mixins: [
    PaginatedDataMapperMixin,
  ],
  props: {
    event: Number
  },
  components: {
    ApplyDialog,
    EditDialog,
    EditTransferDialog
  },
  computed: {
    ...mapGetters({
      getItems: 'intervals/getInterval',
      getCount: 'intervals/getIntervalCount',
      isLoading: 'intervals/isLoadingInterval',
      detailData: 'events/getEventsDetail'
    }),
  },
  data() {
    return {
      pagination: {},
      dialog_add_edit: false,
      dialog_add_transfer: false,
      dialog_delete: false,
      edit_status: undefined,
      docs_data: undefined,
      blockInterval:{
        open: false,
        block: true
      },
      expanded: [],
      selectors: {
        parentCategory: [],
      },
      loading: true,
      headers: [
        {text: 'Начало', sortable: false, align: 'left', value: "started",},
        {text: 'Максимум записей', sortable: false, align: 'center', value: "max_visitors",},
        {text: 'Не выводится', sortable: false, align: 'center', value: "is_blocked",},
        {text: 'Действия', sortable: false, align: 'right', value: "btn",},
      ]
    }
  },

  methods: {
    transferRecords(item){
      this.docs_data = item
      this.dialog_add_transfer= true
    },
    openBlockDialog(item,block){
      this.docs_data = item
      this.blockInterval.block = block
      this.blockInterval.open = true
    },
    closeBlockDialog(event){
      if (event)
        if (this.blockInterval.block === true) {
          this.changeIntervalBlock({
            id: this.docs_data.id,
            date: this.$route.params.date,
            finalizer: (val) => {
              this.blockInterval.open = false
              this.loadData()
            },
          })
        }else {
          this.changeIntervalUnBlock({
            id: this.docs_data.id,
            date: this.$route.params.date,
            finalizer: (val) => {
              this.blockInterval.open = false
              this.loadData()
            },
          })
        }
      this.blockInterval.open = false
    },
    returnParent() {
      this.$router.push({name: names.ADMIN.EVENTS})
    },
    getLeftMenu() {
      let menu = []
      menu.push({title: 'Главная', icon: 'view_quilt', router: names.ADMIN._BASE, name: names.ADMIN._BASE,})
      menu.push({title: 'Назад', icon: 'arrow_back', router: names.ADMIN.EVENTS, name: names.ADMIN.EVENTS,})
      return menu
    },
    displayDate,
    ...mapActions({
      loadList: 'intervals/loadIntervalList',
      changeIntervalBlock: 'intervals/changeIntervalBlock',
      changeIntervalUnBlock: 'intervals/changeIntervalUnBlock',
      deleteRole: 'intervals/deleteInterval',
      loadEventsDetail: 'events/loadEventsDetail'
    }),
    openCreateDialog() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.docs_data = {}
    },
    openEditDialog(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.docs_data = item
    },
    openDeleteDialog(item) {
      this.dialog_delete = true
      this.docs_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.dialog_delete = false
      this.dialog_add_transfer = false
      this.docs_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteRole({
          id: this.docs_data.id,
          date: this.$route.params.date,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
      this.dialog_delete = false
      this.docs_data = undefined
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        date: this.$route.params.date,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
        }
      })
    },
    reloadData() {
      this.loadData()
    },

  },
  created() {
    this.$store.commit('leftmenu/replaceItems', this.getLeftMenu());
    this.loadData()
    this.loadEventsDetail({
      id: this.$route.params.event,}
    )
  }
}
</script>
<style scoped>
</style>
